var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-box"},[_c('div',{ref:"total",staticClass:"main-box",attrs:{"id":"total"}},[(_vm.isReset)?_c('iframe',{attrs:{"src":_vm.reportUrl,"id":"iframe","name":"iframe","frameborder":"0","scrolling":"auto"}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-244a9921","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/XrFileView/index.vue
// module id = null
// module chunks = 